import { Theme } from 'lib/ui/types'

import {
  heading1,
  heading2,
  containerWide,
  container,
  buttonPrimary,
  buttonPrimaryOutline,
  buttonSecondary,
  buttonGreen,
  buttonSizeLg,
  buttonSizeSm,
  link,
  facebookButton
} from './css'

export const sofiaTheme: Theme = {
  maxWidth: '1470px',
  palette: {
    primary: {
      alphaDark: '#EA6797',
      alphaLight: '#FCF4F7',
      alphaMutted: '#ca88a1',
      alpha: '#EFC8D8',
      beta: '#849D67',
      betaLight: '#85B153',
      gamma: '#01AFF4',
      gammaLight: '#a0d7e5'
    },
    general: {
      dark: '#000',
      light: '#FFF',
      strong: '#38291E',
      strongMutted: '#6a5f57',
      stronger: '#141210',
      green: '#00BA3C',
      greyDark: '#767676',
      greyMed: '#949494',
      grey: '#B7B7B7',
      greyLight: '#DBDBDB',
      greyLighter: '#e5e5e5',
      greyMutted: '#c3bebb',
      greyExtraLight: '#f5f5f5',
      blueDark: '#3B5998',
      blueLight: '#00ACED',
      brown: '#45362a',
      red: '#e60023',
      pinkDark: '#B65879',
      pink: '#F5C6D8',
      pinkLight: '#f2e7ea',
      headerColor: '#38291E',
      textColorLight: '#84817F',
      textColor: '#38291E',
      borderColorLight: '#eee',
      borderColor: '#ddd',
      borderColorDark: '#767676',
      soft: '#F0F0F0',
      boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
      buttonSizeDefault: '40px',
      buttonSizeLg: '50px',
      buttonSizeSm: '30px'
    },
    state: {
      success: '#A0D8E5',
      successLighter: '#defff0',
      danger: '#96262C',
      dangerLighter: '#F9DFDE',
      info: '#495459',
      infoLighter: '#E2F6FD',
      alert: '#c89211',
      alertLighter: '#FDD377'
    }
  },
  form: {
    fontColor: '#3F3F3F',
    labelColor: '#3F3F3F',
    indicatorColor: '#A5A5A5',
    placeholderColor: '#BCBCBC',
    passiveColor: '#38291E',
    inputBackgroundColor: '#FFF',
    inputDisabledBackgroundColor: '#EEE',
    innerBoxShadow: 'none',
    boxShadow: '0 0 7px rgba(0, 0, 0, 0.3)',
    borderRadius: '6px'
  },
  font: {
    default: {
      family: 'Catamaran, Arial, sans-serif',
      light: '300',
      normal: '400',
      medium: '600',
      bold: '700'
    },
    alt: {
      family: '"Playfair Display", serif',
      light: '300',
      normal: '400',
      medium: '600',
      bold: '700'
    },
    icon: {
      family: '"Font Awesome 5 Pro"',
      light: '300',
      normal: '400',
      bold: '900'
    },
    iconBrands: {
      family: '"Font Awesome 5 Brands"',
      light: '300',
      normal: '400',
      bold: '900'
    }
  },
  productSelector: {
    darkBg: '#CB88A1',
    bgColor: '#F5C6D8',
    reviewBgColor: '#CFEBF2',
    reviewColorDark: '#A0D8E5',
    checkColor: '#849d67',
    landingAccent: '#62CFE3',
    landingPink: '#F1E2E7'
  },
  css: {
    heading1,
    heading2,
    containerWide,
    container,
    buttonPrimary,
    buttonPrimaryOutline,
    buttonSecondary,
    buttonGreen,
    buttonSizeLg,
    buttonSizeSm,
    link,
    facebookButton
  }
}
